import { render } from "./AIChatPanel.vue?vue&type=template&id=6b27cc05&scoped=true"
import script from "./AIChatPanel.vue?vue&type=script&lang=js"
export * from "./AIChatPanel.vue?vue&type=script&lang=js"

import "./AIChatPanel.vue?vue&type=style&index=0&id=6b27cc05&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b27cc05"]])

export default __exports__